import React from 'react';
import { Box, Container, Typography, CircularProgress, Chip } from '@mui/material';
import Navbar from './Navbar';

/**
 * Shared chrome for GIRVI app screens (Master, Pledge, Transactions, Accounting, Auction, Reports).
 * Same navy/gold hero as Master pages.
 */
export default function GirviPageShell({
  title,
  subtitle = 'GIRVI',
  children,
  loading = false,
  actions = null,
  chipLabel = 'GIRVI',
  maxWidth = 'lg',
  disableNavbar = false,
  compact = false,
}) {
  return (
    <>
      {!disableNavbar ? <Navbar /> : null}
      <Box
        className="girvi-app-page"
        sx={{
          minHeight: 'calc(100vh - 56px)',
          background:
            'radial-gradient(900px 420px at 8% -8%, rgba(201,162,77,0.16), transparent 55%), radial-gradient(700px 360px at 100% 0%, rgba(29,78,216,0.08), transparent 50%), linear-gradient(180deg, #eef2f7 0%, #f7f8fb 45%, #f3f5f8 100%)',
          py: compact ? { xs: 1, md: 1.25 } : { xs: 2, md: 2.5 },
        }}
      >
        <Container maxWidth={maxWidth} sx={{ px: { xs: 1.5, sm: 2 } }}>
          <Box
            sx={{
              mb: compact ? 1.25 : 2,
              p: compact ? { xs: 1.15, md: 1.4 } : { xs: 1.75, md: 2.25 },
              borderRadius: 3,
              background: 'linear-gradient(115deg, #0b1220 0%, #16233a 55%, #1e3a5f 100%)',
              border: '1px solid rgba(212,175,106,0.28)',
              boxShadow: '0 12px 32px rgba(15,23,42,0.14)',
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 1.5,
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontSize: 10,
                  fontWeight: 800,
                  letterSpacing: '0.16em',
                  textTransform: 'uppercase',
                  color: 'rgba(245,230,200,0.7)',
                  mb: 0.4,
                }}
              >
                {subtitle}
              </Typography>
              <Typography
                component="h1"
                sx={{
                  fontSize: compact ? { xs: 17, md: 20 } : { xs: 20, md: 24 },
                  fontWeight: 800,
                  letterSpacing: '-0.02em',
                  color: '#f8fafc',
                  lineHeight: 1.15,
                }}
              >
                {title}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
              {actions}
              <Chip
                size="small"
                label={chipLabel}
                sx={{
                  height: 26,
                  fontWeight: 700,
                  bgcolor: 'rgba(240,217,160,0.14)',
                  color: '#f5e6c8',
                  border: '1px solid rgba(240,217,160,0.35)',
                }}
              />
            </Box>
          </Box>

          {loading ? (
            <Box sx={{ display: 'grid', placeItems: 'center', py: 8 }}>
              <CircularProgress size={36} sx={{ color: '#c9a24d' }} />
            </Box>
          ) : (
            <Box
              sx={{
                borderRadius: 3,
                border: '1px solid #e2e8f0',
                bgcolor: 'rgba(255,255,255,0.92)',
                boxShadow: '0 8px 24px rgba(15,23,42,0.05)',
                p: compact ? { xs: 1, md: 1.35 } : { xs: 1.5, md: 2.25 },
                overflow: 'hidden',
              }}
            >
              {children}
            </Box>
          )}
        </Container>
      </Box>
    </>
  );
}

export const girviPaperSx = {
  p: { xs: 2, md: 2.5 },
  borderRadius: 3,
  border: '1px solid #e2e8f0',
  bgcolor: 'rgba(255,255,255,0.92)',
  boxShadow: '0 8px 24px rgba(15,23,42,0.05)',
};

export const girviSectionTitleSx = {
  fontSize: 15,
  fontWeight: 780,
  color: '#0f172a',
  mb: 1.5,
};
